'use client';

import Image from 'next/image';
import { memo, useEffect, useRef, useState } from 'react';
import styles from './Video.module.scss';

interface Props {
  isActive: boolean;
  link: string;
  linkWebm?: string;
  placeholder?: string;
}

const Video = ({ isActive, link, linkWebm, placeholder }: Props) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  const stopVideo = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };
  useEffect(() => {
    if (videoRef) {
      if (isActive) {
        videoRef.current?.play();
      } else {
        stopVideo();
      }
    }
  }, [isActive]);

  return (
    <>
      {!isLoaded && placeholder && (
        <Image
          src={placeholder}
          alt="placeholder"
          className={styles.placeholder}
          priority
          fill
        />
      )}
      <video
        loop
        muted
        playsInline
        ref={videoRef}
        className={`${styles.video}`}
        onPlay={() => setIsLoaded(true)}
      >
        <source src={linkWebm} type="video/webm" />
        <source src={link} type="video/mp4" />
      </video>
    </>
  );
};

export default memo(Video);
